import { render, staticRenderFns } from "./detail-risk-review.vue?vue&type=template&id=67e360a7&scoped=true"
import script from "./detail-risk-review.vue?vue&type=script&lang=js"
export * from "./detail-risk-review.vue?vue&type=script&lang=js"
import style0 from "./detail-risk-review.vue?vue&type=style&index=0&id=67e360a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e360a7",
  null
  
)

export default component.exports